<template>
  <div class="row read-only articles-read-only">
    <div class="col-12 col-md-8 border-right-mb">
      <div
        class="read-only__badge"
        :style="`color: ${data.channel_content_type.content_type.color};`"
      >
        <div
          class="read-only__badge__background"
          :style="` background: ${data.channel_content_type.content_type.color}; `"
        />
        <span class="ml-auto">
          {{ data.channel_content_type.content_type.name }}
        </span>
        <icon
          v-tooltip.top="data.channel_content_type.content_type.name"
          :icon="data.channel_content_type.content_type.icon"
          class="mb-0 ml-1"
        />
      </div>

      <div class="d-flex flex-column read-only__item">
        <label class="text-black"> Published At </label>

        <span
          v-date="{
            date: data.published_at,
            format: $settings.dateTimeFormat,
            isIso: true,
          }"
        />
      </div>

      <div class="d-flex flex-column read-only__item">
        <label class="text-black"> Article Title </label>
        <div>
          {{ data.title }}
        </div>
      </div>

      <div class="d-flex flex-column read-only__item">
        <label class="text-black"> Synopsis </label>
        <div v-html="data.teaser_text" />
      </div>

      <div class="d-flex flex-column read-only__item">
        <label class="text-black"> PDF </label>
        <div>
          {{ data.pdf || 'Not processed yet' }}
        </div>
      </div>

      <div class="d-flex flex-column read-only__item">
        <label class="text-black"> Authors </label>
        <div class="tag-input">
          <div class="tag-input__list">
            <span
              v-for="author in data.analysts"
              :key="author.name"
              class="tag-input__list__item link"
            >
              {{ author.name }}
            </span>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column read-only__item">
        <label class="text-black"> Tags </label>
        <div class="tag-input">
          <div class="tag-input__list">
            <span
              v-for="tag in data.tags"
              :key="tag.name"
              class="tag-input__list__item link"
            >
              {{ tag.name }}
            </span>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column read-only__item">
        <label class="text-black"> Companies </label>
        <div class="tag-input">
          <div class="tag-input__list">
            <span
              v-for="company in data.companies"
              :key="company.name"
              class="tag-input__list__item link"
            >
              {{ company.name }}
            </span>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column read-only__item">
        <label class="text-black"> Alert Top Right </label>
        <span>
          {{ data.alert_top_right }}
        </span>
      </div>

      <div class="d-flex flex-column read-only__item">
        <label class="text-black"> Alerts </label>
        <div class="tag-input">
          <div class="tag-input__list">
            <router-link
              v-for="alert in alerts"
              :key="alert.id"
              class="tag-input__list__item link"
              :to="{ name: 'alerts.view', params: { alertId: alert.id } }"
            >
              {{ alert.subject }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-4 pad-left-1">
      <div v-if="entities" class="entities">
        <h2 class="mb-4">Entities</h2>

        <vue-good-table
          :rows="filteredEntities"
          styleClass="vgt-table"
          :columns="tableColumns"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'before'">
              <div
                v-tooltip="
                  filteredEntities[props.$index].category.name.substr(0, 1) +
                  filteredEntities[props.$index].category.name
                    .substr(1)
                    .toLowerCase()
                "
                :style="{
                  'background-color':
                    filteredEntities[props.$index].category.color,
                }"
                class="rounded-circle"
                style="height: 15px; width: 15px"
              />
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import Date from '@/directives/date'
import Prism from 'prismjs';
import 'prismjs/themes/prism.min.css'

export default {
  components: {
    VueGoodTable,
  },

  directives: {
    Date,
  },

  props: {
    data: {
      type: Object,
      default: null,
    },
    alerts: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      entities: null,
      tableColumns: [
        {
          label: '',
          field: 'before',
        },
        {
          label: 'Score',
          field: 'prettyScore',
        },
        {
          label: 'Count',
          field: 'count',
        },
        {
          label: 'Text',
          field: 'text',
        },
      ],
    }
  },

  mounted() {
    this.getEntities()

  },

  computed: {
    filteredEntities() {
      return this.entities
        .filter(function (val) {
          return (
            val.score >= 0.95 &&
            ['ORGANIZATION', 'PEOPLE', 'LOCATION'].indexOf(
              val.category.name
            ) !== -1
          )
        })
        .map(function (val) {
          val.prettyScore =
            val.score.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0] * 100

          return val
        })
    },
  },

  methods: {
    getEntities() {
      this.$http
        .get(`/articles/${this.$route.params.articleId}/entities`)
        .then((response) => {
          this.entities = response.data.data
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.articles-read-only {
  .header {
    overflow: hidden;
    padding: 12px 0 0;
    &__type {
      min-width: 250px;
      &__icon {
        width: 1.25rem;
        height: 1.25rem;
        margin: 3px 0 0 0;
      }
    }
  }

  .entities {
    clear: both;
  }

  .badge-light {
    color: $gray-600;
  }
}
</style>
